import Vue from 'vue'
import _ from 'lodash'

const state = {
    menu: []
};

const getters = {
    getMenu: state => {
        return state.menu;
    },
    findRouteTitle: state => routeName => {

        const menuItem = _.find(allMenuItems, {routeName});

        if (menuItem) {
            return menuItem.title;
        }
        return null;
    },
    isSUMenuItem: state => routeName => {
        return !!_.find(fullMenuSu, {name:routeName}) && !_.find(fullMenu, {name:routeName});
    }
};

const mutations = {
    initialize(state) {
        Vue.set(state, 'menu', [])
    },
    setMenu(state, menuItems) {
      Vue.set(state, 'menu', menuItems)
    }
};

const allMenuItems = {
    // regular linked on home page
    'gettingStarted': { icon: 'fa-fw far fa-tachometer-alt-slowest', title: 'Get Started', url: '#/admin/gettingStarted', pageSeq: 1, spacingAdjustment: '-1px' },
    'systemList': { icon: 'fa-fw far fa-th', title: 'Infrastructure', url: '#/admin/infrastructure/list', pageSeq: 2 },
    'upgradeCollector': { icon: 'fa-fw far fa-download', title: 'Upgrade Collector', url: '#/admin/upgradeCollector', pageSeq: 3 },
    'endpointList': { icon: 'fa-fw far fa-video-plus', title: 'Endpoints', url: '#/admin/endpoints/list', pageSeq: 4, spacingAdjustment: '-1px' },
    'buildings': { icon: 'fa-fw far fa-building', title: 'Buildings', url: '#/admin/datasets/buildings', pageSeq: 5, spacingAdjustment: '1px' },
    'spaces': { icon: 'fa-fw far fa-door-open', title: 'Spaces', url: '#/admin/datasets/spaces', pageSeq: 5, spacingAdjustment: '1px' },
    'networks': { icon: 'fa-fw far fa-diagram-project', title: 'Networks', url: '#/admin/datasets/networks', pageSeq: 5, spacingAdjustment: '1px' },
    'sensors': { icon: 'fa-fw far fa-sensor', title: 'Sensors', url: '#/admin/datasets/sensors', pageSeq: 5, spacingAdjustment: '1px' },
    'userList': { icon: 'fa-fw far fa-users', title: 'Users', url: '#/admin/users/list', pageSeq: 6, spacingAdjustment: '-2px' },
    'monitorGroupsList': { icon: 'fa-fw far fa-layer-group', title: 'Monitoring Groups', url: '#/admin/endpoints/monitorGroupsList', pageSeq: 7 },
    'accountSettings': { icon: 'fa-fw far fa-cog', title: 'Account Settings', url: '#/admin/settings', pageSeq: 8 },
    'entitlements': { icon: 'far fa-id-card', title: 'Entitlements', url: '#/admin/entitlements', pageSeq: 9 },
    // regular not on home page
    'auditHistory': { icon: 'fa-layer-group', title: 'Audit History', url: '#/admin/auditHistory'},
    'welcome': { icon: 'fa-fw far fa-house', title: 'Home', url: '#/admin/welcome' },
    'newSystem': { icon: 'fa-fw far fa-devices', title: 'Add New Infrastructure', url: '#/admin/infrastructure/new'  },

    // su linked on home page
    'appConfigs': { icon: 'fa-fw far fa-cogs', title: 'Configuration', url: '#/admin/configs', suOnly: true, pageSeq: 10, spacingAdjustment: '-2px' },
    'collectorDrivers': { icon: 'fa-fw far fa-hdd', title: 'Drivers', url: '#/admin/collectors/drivers', suOnly: true, pageSeq: 11, spacingAdjustment: '-1px' },
    'collectorLogs': { icon: 'fa-fw far fa-th-list', title: 'Logs', url: '#/admin/collectors/logs', suOnly: true, pageSeq: 12 },
    'collectorMetrics': { icon: 'fa-fw far fa-chart-line', title: 'Metrics', url: '#/admin/collectors/metrics', suOnly: true, pageSeq: 13 },
    'documents': { icon: 'fa-fw far fa-files', title: 'Documents', url: '#/admin/datasets/documents', suOnly: true, pageSeq: 15},
    'all-documents': { icon: 'fa-fw far fa-cabinet-filing', title: 'All Documents', url: '#/admin/datasets/all-documents', suOnly: true},
    'last-documents': { icon: 'fa-fw far fa-folder-arrow-up', title: 'Last Documents', url: '#/admin/datasets/last-documents', suOnly: true},
    // su not linked on home page
    'crossOrg': { icon: 'fa-fw far fa-user-shield', title: 'Super User', url: '#/admin/superUser', suOnly: true, color: 'orange', spacingAdjustment: '-2px' },
};

function getMenuItem(name) {
    return _.assign({name:name}, allMenuItems[name]);
}

const govMenu = [
    getMenuItem('welcome'),
    getMenuItem('gettingStarted'),
    getMenuItem('systemList'),
    getMenuItem('upgradeCollector'),
    getMenuItem('endpointList'),
    getMenuItem('buildings'),
    getMenuItem('spaces'),
    getMenuItem('networks'),
    getMenuItem('sensors'),
    getMenuItem('userList'),
    getMenuItem('monitorGroupsList'),
    getMenuItem('accountSettings'),
    // getMenuItem('auditHistory')
];

const fullMenu = [
    getMenuItem('welcome'),
    getMenuItem('gettingStarted'),
    getMenuItem('systemList'),
    getMenuItem('upgradeCollector'),
    getMenuItem('endpointList'),
    getMenuItem('buildings'),
    getMenuItem('spaces'),
    getMenuItem('networks'),
    getMenuItem('sensors'),
    getMenuItem('userList'),
    getMenuItem('monitorGroupsList'),
    getMenuItem('accountSettings'),
    getMenuItem('entitlements')
    // getMenuItem('auditHistory')
];

const fullMenuSu = [
    getMenuItem('welcome'),
    getMenuItem('gettingStarted'),
    getMenuItem('systemList'),
    getMenuItem('upgradeCollector'),
    getMenuItem('endpointList'),
    getMenuItem('buildings'),
    getMenuItem('spaces'),
    getMenuItem('networks'),
    getMenuItem('sensors'),
    getMenuItem('userList'),
    getMenuItem('monitorGroupsList'),
    getMenuItem('accountSettings'),
    getMenuItem('entitlements'),
    // getMenuItem('auditHistory'),
    Object.assign(getMenuItem('appConfigs'), {separator: true}),
    getMenuItem('collectorDrivers'),
    getMenuItem('collectorLogs'),
    getMenuItem('collectorMetrics'),
    getMenuItem('documents'),
    Object.assign(getMenuItem('crossOrg'), {separator: true}),
    getMenuItem('all-documents'),
    getMenuItem('last-documents')
];

const actions = {
    setMenus({ commit, rootGetters }, currentRouteName) {
        let menu = [];
        if (rootGetters['user/isSU']) {
            menu = fullMenuSu;
        } else if (!window.pendo){
            menu = govMenu;
        } else {
            menu = fullMenu;
        }
        commit('setMenu', menu);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
